import { Component, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, IonSelect, LoadingController, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { coutryPostalMatchValidator, creditCardExpiryValidator, DEPOSIT_PATTERN, NAME_PATTERNV2, POboxValidator, POboxValidatorGroup } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CashierBase } from '../../cashier-base/cashier-base';

@Component({
  selector: 'app-deposit-creditcard',
  templateUrl: './deposit-creditcard.component.html',
  styleUrls: ['./deposit-creditcard.component.scss'],
})
export class DepositCreditcardComponent extends CashierBase implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public bonusOffer: any;
  @Input() public navigateBackPage: any;


  public error = null;

  public bonusCode: string;
  public customer: any;
  public defaultAmounts: any = [];
  public labels: DepositMainLabels;
  public paymentType: any = [];
  public minAmount: any;
  public countries = [];
  public provinces;
  public cards: any = [];
  public selectedCard: string;
  public cardExpMonths: any = [];
  public cardExpYears: any = [];
  public selectedCountry: string = "";
  public selectedProvince: string = "";
  public selectedCountryCode: string = "";
  public stateProvinceLabel: string = "";
  public zipPostalCodeLabel: string = "";

  public selectedMonth: string;
  public selectedYear: string;
  public buttonDisabled: boolean = false;

  public isExistingCard: boolean;
  public isExistingCardList: boolean;
  public showCVV: boolean = false;

  public depositForm: FormGroup;
  public amount: AbstractControl;
  public paymentTypeCode: AbstractControl;
  public country: AbstractControl;
  public province: AbstractControl;
  public cardList: AbstractControl;
  public cardNumber: AbstractControl;
  public cardCvc: AbstractControl;
  public cardExpiryGroup: AbstractControl;
  public cardExpMonth: AbstractControl;
  public cardExpYear: AbstractControl;
  public streetGroup: AbstractControl;
  public street: AbstractControl;
  public street2: AbstractControl;
  public city: AbstractControl;
  public countryInfoGroup: AbstractControl;
  public postalCode: AbstractControl;
  public name: AbstractControl;
  public firstName: AbstractControl;
  public lastName: AbstractControl;
  public environmentName: string = "";

  public isAVS: boolean = this.configService.getConfig().FEATURE_CREDITCARD_AVS == "1";
  public loading: any;
  @ViewChildren(IonSelect) ionSelect: QueryList<IonSelect>;

  maxCCYears: number;
  refreshed: boolean = false;

  constructor(
    public addressService: AddressService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public configService: ConfigService,
    public events: EventsService,
    public navigator: Navigator,
    public UserSessionService: UserSessionService,
    public utils: UtilsService,
    public successMessageService: SuccessMessageService,
    public loadingController: LoadingController,
    private platform: Platform
  ) {
    super();

    this.getCustomer();
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
    this.environmentName = this.configService.getState()?.toLowerCase();
    this.changeSelectInterface();
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading...',
      duration: 3000
    });

    this.loading.present();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.changeSelectInterface();
  }


  changeSelectInterface() {
    setTimeout(() => {
      this.ionSelect.forEach((ionSelect: IonSelect) => {
        if (ionSelect) {
          // changing the interface to alert if it is IOS Mobile
          ionSelect.interface = this.isIOSMobile() ? "alert" : "popover";
        }
      });
    }, 1000);
  }


  isCapacitor() {
    return this.platform.is('capacitor');
  }

  isIOSMobile() {
    return this.platform.is('ios') && this.platform.is('capacitor');
  }

  ngOnInit() {
    this.maxCCYears = Number(this.configService.getConfig().FEATURE_CREDIT_CARD_EXPIRY_MAX_YEARS) || 15;

    this.selectedCountry = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    if (this.selectedCountry === 'CANADA') {
      this.selectedCountryCode = 'CAN';
      this.stateProvinceLabel = 'Province';
      this.zipPostalCodeLabel = 'Postal Code';
    } else {
      this.selectedCountryCode = 'USA';
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    }

    this.depositForm = new FormGroup({
      amount: new FormControl({ value: '', disabled: false }, { validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change' }),
      cardList: new FormControl({ value: '', disabled: false }),
      paymentTypeCode: new FormControl({ value: '', disabled: false }, [Validators.required]),
      countryInfoGroup: new FormGroup({
        country: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required]),
        postalCode: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required])
      }, coutryPostalMatchValidator),
      cardNumber: new FormControl({ value: '', disabled: false }, [Validators.minLength(15), Validators.maxLength(16), Validators.pattern('^[0-9]*')]),
      cardExpiryGroup: new FormGroup({
        cardExpMonth: new FormControl({ value: '', disabled: false }, [Validators.required]),
        cardExpYear: new FormControl({ value: '', disabled: false }, [Validators.required]),
      }, creditCardExpiryValidator),
      firstName: new FormControl({ value: this.customer.firstName, disabled: false }),
      lastName: new FormControl({ value: this.customer.lastName, disabled: false }),
      name: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required, Validators.pattern(NAME_PATTERNV2)]),
      cardCvc: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3), Validators.pattern('^[0-9]*')]),
      streetGroup: new FormGroup({
        street: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required, POboxValidator]),
        street2: new FormControl({ value: '', disabled: this.isNotEditable() }, [POboxValidator]),
      }, POboxValidatorGroup),
      city: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required]),
      province: new FormControl({ value: '', disabled: this.isNotEditable() }, [Validators.required]),
    });


    // Getting Form Data
    this.amount = this.depositForm.get('amount');
    this.cardNumber = this.depositForm.get('cardNumber');
    this.cardList = this.depositForm.get('cardList');
    this.paymentTypeCode = this.depositForm.get('paymentTypeCode');

    this.cardExpiryGroup = this.depositForm.get('cardExpiryGroup');
    this.cardExpMonth = this.cardExpiryGroup.get('cardExpMonth');
    this.cardExpYear = this.cardExpiryGroup.get('cardExpYear');

    this.firstName = this.depositForm.get('firstName');
    this.lastName = this.depositForm.get('lastName');
    this.name = this.depositForm.get('name');
    this.cardCvc = this.depositForm.get('cardCvc');

    this.streetGroup = this.depositForm.get('streetGroup');
    this.street = this.streetGroup.get('street');
    this.street2 = this.streetGroup.get('street2');
    this.countryInfoGroup = this.depositForm.get('countryInfoGroup');
    this.country = this.countryInfoGroup.get('country');
    this.postalCode = this.countryInfoGroup.get('postalCode');
    this.province = this.depositForm.get('province');
    this.city = this.depositForm.get('city');

    this.onGetAccounts(false);
    this.generateExpiryMonths();
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);

    // Mark name field as touched and dirty if prefilled value is invalid
    if (this.customer?.firstName && this.customer?.lastName) {
      const fullName = this.customer.firstName + ' ' + this.customer.lastName;
      this.name.setValue(fullName);
      if (this.name.invalid) {
        this.name.markAsTouched();
        this.name.markAsDirty();
      }
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('CREDIT').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        if (this.paymentType.length > 1) {
          this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
        }
      }
    }, (error) => {
      console.error("Type category error", error);
    }
    );
    this.getAllCountries();
    this.content.scrollToTop();
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('creditcard').then((response: DepositMainLabels) => {
      this.labels = response;
    });
    this.getAllCountries();
  }

  public onSubmit() {
    if (this.isExistingCard == true) return this.onDeposit(null);
    return this.onAddCard();
  }

  public getCustomer() {
    this.UserSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
        if (this.name && customer.firstName && customer.lastName) {
          this.name.setValue(customer?.firstName + ' ' + customer?.lastName);
        }
      });
    });
  }

  public onGetAccounts(justRefreshList: boolean) {
    this.cards = [];
    this.cashierService.callListAccounts().subscribe((response: any) => {
      if (response && !!response.result) {
        let tempCards: any = response.payload;
        let i = 0;

        for (let index in tempCards) {
          if (this.cardFilter(tempCards, index)) {
            tempCards[index].id = i;
            i++;
            this.cards.push(tempCards[index]);
          }
        }

        if (!!this.cards[0]) {
          this.selectedCard = this.cards[0].id;
          this.minAmount = this.cards[0].minAmount;
          this.onRadioChecked(0);
          this.isExistingCardList = true;
        }

        if (justRefreshList == false) {
          this.onLoadElement();
        }
      }
    });
  }

  public cardFilter(cards, index) {
    if (cards[index].paymentTypeCode == "VI") return true;
    if (cards[index].paymentTypeCode == "MC") return true;
    if (cards[index].paymentTypeCode == "AM") return true;
    if (cards[index].paymentTypeCode == "DIS") return true;
    return false;
  };

  public onAddCard() {
    this.buttonDisabled = false;
    this.successMessageService.clearMessage();
    this.error = null;

    let addCardFormObj: any = this.depositForm.value;
    let payment_type_code: string = this.depositForm.controls['paymentTypeCode'].value;

    addCardFormObj.payment_type_code = payment_type_code;
    addCardFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
    addCardFormObj.cardExpMonth = this.cardExpiryGroup.get('cardExpMonth').value;
    addCardFormObj.cardExpYear = this.cardExpiryGroup.get('cardExpYear').value;

    this.cashierService.callAddAccount(addCardFormObj).subscribe((response: any) => {
      if (response && !!response.result) {
        if (response.payload != null) {
          return this.onDeposit(response.payload.customerAccountID);
        }
      }
      this.content.scrollToTop(10);
      this.buttonDisabled = true;
    }, (error) => {
      this.error = this.handleError(error);
      this.buttonDisabled = true;
      this.content.scrollToTop(10);
    });
  }

  onDeposit(customerAccountID?: string) {
    // this.content.scrollToTop(10);
    this.showLoading();

    this.buttonDisabled = false;
    this.successMessageService.clearMessage();
    this.error = null;

    let depositFormObj: any = this.depositForm.value;

    if (this.bonusCode != '') depositFormObj.bonusCode = this.bonusCode;

    depositFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;

    if (this.isExistingCard == true) {
      let cardList: AbstractControl = this.depositForm.get('cardList');
      let index: number = cardList.value;

      depositFormObj.payment_type_code = this.cards[index].paymentTypeCode;
      depositFormObj.customerAccountID = this.cards[index].customerAccountID;
    } else {
      depositFormObj.customerAccountID = customerAccountID;
      let payment_type_code: string = this.depositForm.controls['paymentTypeCode'].value;
      depositFormObj.payment_type_code = payment_type_code;
    }

    //Pass CardExpiry Month/Year
    depositFormObj.cardExpMonth = this.cardExpiryGroup.get('cardExpMonth').value;
    depositFormObj.cardExpYear = this.cardExpiryGroup.get('cardExpYear').value;


    this.cashierService.callCreditCardDeposit(depositFormObj).subscribe((response: any) => {
      if (response && !!response.result) {
        setTimeout(() => this.depositForm.reset(), 500);
        /*let depositEventData: AffiliateTrackerCallbackParams = {
          customer_id: this.cashierService.customer.customerId,
          amount: depositFormObj.amount,
          transaction_id: response.payload.paymentRequestID,
          paymentMethod: 'CREDIT_CARD',
        };

        setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
        this.loading.dismiss();
        let exceededDepositLimit = false;
        if ('hasExceededDepositLimit' in response.payload) {
          exceededDepositLimit = response.payload.hasExceededDepositLimit;
        }

        if (exceededDepositLimit) {
          this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.amount.value, customerId: this.customer.customerId });
        } else {
          const displayMessage: string = '$' + this.amount.value + " has been added to your account.";
          this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: true, message: displayMessage });
        }
      } else {
        this.loading.dismiss();
        this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: 'Please Contact Support' });
      }
      this.buttonDisabled = true;

    }, (error) => {
      this.buttonDisabled = true;
      this.error = this.handleError(error);
      setTimeout(() => this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: this.error.error_message }), 1500)
    });

  }

  public onChangeCountry(event) {
    this.getProvinces(event.target.value)
  }

  public onPaymentType(data) {

    let i: number = 0;

    this.defaultAmounts = [];

    while (i < 11) {
      if (typeof this.paymentType[data]['default_amt_' + (i + 1)] !== 'undefined') {
        this.defaultAmounts.push(this.paymentType[data]['default_amt_' + (i + 1)])
      } else {
        break;
      }
      i++;
    }
    this.minAmount = this.paymentType[data].min;
  }

  public onLoadElement() {
    if (this.cards.length > 0) {
      this.isExistingCard = true;
      this.buttonDisabled = false;
      this.depositForm.removeControl("cardNumber");
      this.depositForm.removeControl("paymentTypeCode");
      return this.getAllCountries();
    }

    this.isExistingCard = false;
    this.onUseDifferentCard()
    return this.getAllCountries();
  }

  public onUseDifferentCard() {
    this.paymentType.forEach(p => {
      if (p.code === this.paymentTypeCode.value) {
        this.minAmount = p.min;
      }
    })

    this.isExistingCard = false;
    this.buttonDisabled = true;
    //this.depositForm.removeControl("cardList");
    this.depositForm.addControl("cardNumber", this.cardNumber);
    this.depositForm.addControl("paymentTypeCode", this.paymentTypeCode);
    this.depositForm.get("cardNumber").setValidators([Validators.required, Validators.minLength(15), Validators.maxLength(16), Validators.pattern('^[0-9]*')]);
    this.depositForm.get("cardNumber").setValue("");
    this.depositForm.get("cardNumber").markAsPristine();
    this.depositForm.get("cardNumber").markAsUntouched();
    // this.depositForm.addControl("streetGroup", this.streetGroup);

    this.streetGroup.get("street").setValue(this.customer.address.street);
    if (!isUndefined(this.customer.address.street2) && !(/\s+/g.test(this.customer.address.street2))) {
      this.streetGroup.get("street2").setValue(this.customer.address.street2);
    } else {
      this.streetGroup.get("street2").setValue("");
    }

    // this.depositForm.addControl("countryInfoGroup", this.countryInfoGroup);
    this.countryInfoGroup.get("postalCode").setValue(this.customer.address.postalCode);
    // this.depositForm.addControl("province", this.province);
    this.depositForm.get("province").setValue(this.customer.address.state);
    // this.depositForm.addControl("city", this.city);
    this.depositForm.get("city").setValue(this.customer.address.city);

    this.onClearFields();
    this.isExistingCard = false;
  }

  public onRadioChecked(index: number) {
    this.minAmount = this.cards[index].minAmount;
    this.isExistingCard = true;
    this.buttonDisabled = true;

    this.depositForm.get("firstName").setValue(this.cards[index].firstName);
    this.depositForm.get("firstName").markAsDirty();
    this.depositForm.get("firstName").markAsTouched();

    this.depositForm.get("lastName").setValue(this.cards[index].lastName);
    this.depositForm.get("lastName").markAsDirty();
    this.depositForm.get("lastName").markAsTouched();

    this.streetGroup.get("street").setValue(this.cards[index].address1);
    if (!isUndefined(this.cards[index].address2) && !(/^\s+$/g.test(this.cards[index].address2))) {
      this.streetGroup.get("street2").setValue(this.cards[index].address2);
    } else {
      this.streetGroup.get("street2").setValue("");
    }

    if (!isUndefined(this.cards[index].postalCode)) {
      this.countryInfoGroup.get("postalCode").setValue(this.cards[index].postalCode);
    } else {
      this.countryInfoGroup.get("postalCode").setValue("");
    }
    this.depositForm.get("province").setValue(this.cards[index].state);

    if (this.countries.length > 0) {
      this.countryInfoGroup.get('country').setValue(this.cards[index].country);
    }

    this.depositForm.get('city').setValue(this.cards[index].city);

    this.selectedMonth = this.cards[index].expirationMonth;
    this.selectedYear = this.cards[index].expirationYear;

    //this.onGetAccounts(false);
    this.depositForm.removeControl("cardNumber");
    this.onClearFields();
    this.buttonDisabled = false;
  }

  public onClearFields() {
    this.depositForm.get("cardCvc").setValue("");
    this.depositForm.get("cardCvc").markAsPristine();
    this.depositForm.get("cardCvc").markAsUntouched();

    this.selectedMonth = "";
    this.selectedYear = "";
  }

  public getAllCountries() {
    this.addressService.callGetAllCountries().subscribe((response: any) => {
      if (response && !!response.result) {
        const countriesList: any = response.payload;
        let cardSelected: any = this.cards.filter((card) => card.id == this.selectedCard);

        for (let c in countriesList) {
          this.countries.push(countriesList[c]);
        }

        this.selectedCountry = this.onSelectCountry(cardSelected, countriesList);
        if (this.selectedCountry === 'CANADA') {
          let indexOfCanada = countriesList.findIndex(({ name }) => name === 'CANADA');
          let canadaObject = countriesList[indexOfCanada]
          if (this.countries[0].code !== canadaObject.code) this.countries.unshift(canadaObject)
          this.selectedCountryCode = 'CAN';
          this.stateProvinceLabel = 'Province';
          this.zipPostalCodeLabel = 'Postal Code';
        } else {
          this.selectedCountryCode = 'USA';
          this.stateProvinceLabel = 'State';
          this.zipPostalCodeLabel = 'Zip Code';
        }
        this.updateCountryField();
        this.getProvinces();
      }
    }, error => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    })
  }

  public onSelectCountry(cardSelected: any, countriesList: any): any {
    const country = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    if (!!cardSelected && cardSelected.length > 0) return (cardSelected[0].country ? (cardSelected[0].country == 'CAN' ? 'CANADA' : 'USA') : 'USA');
    if (this.countries.length >= 1) return country;
    return this.customer.address.country;
  }

  //Force ion-select interface to display the value in UI.
  public updateCountryField() {
    setTimeout(() => {
      let formGroup = this.depositForm.get('countryInfoGroup');
      formGroup.get('country').patchValue(this.selectedCountryCode);
      this.refreshed = true;
    }, 500);
  }

  public getProvinces(country?: any) {

    let countryName = country ?? this.selectedCountry;

    return new Promise((resolve, reject) => {
      this.addressService.callGetStatesByCountry(countryName === "CANADA" ? "CAN" : countryName).subscribe((response: any) => {
        if (response && !!response.result) {

          const provs = response.payload;
          this.provinces = [];
          for (let p in provs) {
            this.provinces.push({ code: p, name: provs[p] })
          }

          let cardSelected = this.cards.filter((card) => {
            return card.id === this.selectedCard;
          });

          if (cardSelected.length > 0) {
            this.selectedProvince = cardSelected[0].state;
            return resolve(true);
          }

          if (this.customer.address.state)
            this.selectedProvince = this.customer.address.state;
          return resolve(true);
        }
      }, (error) => {
        this.error = this.handleError(error);
        this.content.scrollToTop(10);
        reject();
      });
    })
  }

  public isNotEditable() {
    if (this.isAVS) return true;
    return false;
  }

  public radioChangedCard(e) {
    if (e.target.value == 'diff') return this.onUseDifferentCard();
    return this.onRadioChecked(e.target.value);
  }

  public onAmountSelected(data) {
    return this.depositForm.get('amount').setValue(data);
  }

  public generateExpiryMonths() {
    this.cardExpMonths = [
      { key: '1', value: 'Jan (1)' },
      { key: '2', value: 'Feb (2)' },
      { key: '3', value: 'Mar (3)' },
      { key: '4', value: 'Apr (4)' },
      { key: '5', value: 'May (5)' },
      { key: '6', value: 'Jun (6)' },
      { key: '7', value: 'Jul (7)' },
      { key: '8', value: 'Aug (8)' },
      { key: '9', value: 'Sep (9)' },
      { key: '10', value: 'Oct (10)' },
      { key: '11', value: 'Nov (11)' },
      { key: '12', value: 'Dec (12)' },
    ];

    let d = new Date();
    let y = d.getFullYear();
    let i;

    for (i = 0; i <= this.maxCCYears; i++) {
      this.cardExpYears.push(y + i);
    }
    return;
  }

  public onCVVClick() {
    this.showCVV = true;
    setTimeout(() => {
      this.showCVV = false;
    }, 10 * 1000);
  }

  public getPaymentImage(name: string): string {
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(name)})`;
    return imageUrl;
  }

  public getCardImage(paymentTypeCode: string) {

    let imageName: string;

    for (let item in this.paymentType) {
      if (this.paymentType[item].code == paymentTypeCode) {
        imageName = this.paymentType[item].image_url;
      }
    }

    let imageURL: string = this.getPaymentImage(imageName);
    return imageURL;
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  ngOnDestroy() { }
  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }
}
